<ng-template #headerTemplateView>
  <div class="flex align-items-center justify-content-between w-full">
    <h3 class="m-0 font-semibold text-xl">
      {{ (servico ? 'BARDO_SERVICOS.EDITAR' : 'BARDO_SERVICOS.NOVO') | translate: { termo: $nicho().servico.singular } }}
    </h3>
  </div>
</ng-template>

<ng-template #footerCriarTemplate>
  <div class="flex w-full align-items-center justify-content-end gap-2 p-3">
    <p-button
      [label]="'GLOBAL.CANCELAR' | translate"
      [text]="true"
      severity="secondary"
      (click)="fecharModal()"
      [disabled]="$isLoading()"
    />
    <p-button
      [label]="(servico ? 'GLOBAL.SALVAR' : 'BARDO_SERVICOS.CRIAR') | translate: { termo: $nicho().servico.singular }"
      icon="pi pi-check"
      (click)="salvar()"
      [loading]="$isLoading()"
    />
  </div>
</ng-template>


@if (deviceService.$isMobile() && $visible()) {
<lib-bottom-sheet
  [visible]="$visible()"
  (visibleChange)="onSheetVisibleChange($event)"
  size="medium"
  [draggable]="true"
  [closeOnBackdrop]="!$isLoading()"
  [closeOnEscape]="!$isLoading()"
  [preventClose]="$isLoading()"
  [headerTemplate]="headerTemplateView"
  [footerTemplate]="footerCriarTemplate"
  (hide)="fecharModal()"
>
  <div class="flex flex-column gap-4 pb-4">
    <lib-servico-criar-editar
      #servicoCriarRef
      [servico]="servico"
      [tipoServicoId]="tipoServicoId"
      (salvo)="onServicoSalvo()"
      (cancelar)="fecharModal()"
      (loadingChange)="$isLoading.set($event)"
    />
  </div>
</lib-bottom-sheet>
} @else {
<p-dialog
  [visible]="$visible()"
  (visibleChange)="onSheetVisibleChange($event)"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [showHeader]="true"
  styleClass="dialog-mobile-scroll rounded-3xl shadow-4"
  [style]="{ width: '600px', height: 'auto' }"
  (onHide)="fecharModal()"
>
  <ng-template pTemplate="header">
    <ng-container *ngTemplateOutlet="headerTemplateView"></ng-container>
  </ng-template>

  @if ($visible()) {
    <div class="flex flex-column gap-4 pb-4 p-2">
      <lib-servico-criar-editar
        #servicoCriarRef
        [servico]="servico"
        [tipoServicoId]="tipoServicoId"
        (salvo)="onServicoSalvo()"
        (cancelar)="fecharModal()"
        (loadingChange)="$isLoading.set($event)"
      />
    </div>
  }

  <ng-template pTemplate="footer">
    <ng-container *ngTemplateOutlet="footerCriarTemplate"></ng-container>
  </ng-template>
</p-dialog>
}
